export default __webpack_public_path__ + "static/terraform-b8f84da9762eec50a4cf88814228a214.png";